<div>
  <svg-icon src='./assets/icons/close-outline.svg'
            class="menu-action-icon svg-icon-large svg-icon-red" (click)="closeProjectDetails()" title="{{ 'raci.generalTasks.close' | translate | uppercase }}"></svg-icon>
</div>
<div class="title"> {{'raci.userProjectDetails.title' | translate}}</div>
<div class="description">
  {{'raci.userProjectDetails.description1' | translate}}
</div>
<div class="description">
  {{'raci.userProjectDetails.description2' | translate}}
</div>
<div class="properties-table">
  <kendo-grid class="kendo-white-grid raci-participants-grid project-details-grid"
              [data]="propertyDifferences">
    <kendo-grid-column field="PropertyLabel" title="Label" [width]="40">

    </kendo-grid-column>
    <kendo-grid-column field="PixWF" title="PixWF" [width]="40"></kendo-grid-column>
    <kendo-grid-column field="CapForce" title="CapForce" [width]="40"></kendo-grid-column>
  </kendo-grid>
</div>
